import React, { ReactNode } from "react";

type ButtonProps = {
  children: ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
  ariaLabel?: string;
};

const ButtonIcon = ({ children, className, onClick, isDisabled, ariaLabel = ''}: ButtonProps) => {
  return (
    <button onClick={onClick}
      disabled={isDisabled}
      aria-label={ariaLabel}
      className={`flex ${isDisabled ? 'opacity-60' : 'hover:text-white cursor-pointer hover:bg-dusty-blue'}  transition-colors h-[3.2rem] w-[3.2rem] items-center  justify-center bg-dusty-green text-btn ${className || ""}`}
    >
      {children}
    </button>
  );
};

export default ButtonIcon;